import { render, staticRenderFns } from "./NextOfficialNotice.vue?vue&type=template&id=4456c46a&scoped=true&"
import script from "./NextOfficialNotice.vue?vue&type=script&lang=js&"
export * from "./NextOfficialNotice.vue?vue&type=script&lang=js&"
import style0 from "./NextOfficialNotice.vue?vue&type=style&index=0&id=4456c46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4456c46a",
  null
  
)

export default component.exports